import * as React from 'react';

export interface AreaChartProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /**
   * Array of Areat Chart items
   * * `value` - Item's value.
   * * `label` - A Short label under the value.
   */
  data: IDatasetItem[];
  /** Tooltip content template function*/
  tooltipContent?(item: IDatasetItem, index: number): string | string[];
  /** Callback on tooltip content show event */
  onTooltipShow?(item: IDatasetItem): void;
  /** Maximum ticks allowed in Y axis
   * @default 5
   */
  maxYTicksLimit?: number;
}

export interface IDatasetItem {
  value: number;
  label: string;
}

export class AreaChart extends React.PureComponent<AreaChartProps> {}
